import React, { useEffect } from "react";
import Lottie from "lottie-react";
import loading from "./assets/loading.json";

export default function Loading({ setWno }) {
  useEffect(() => {
    setTimeout(() => {
      setWno(3);
    }, 3000);

    return () => {};
  }, []);

  return (
    <div className="text-center">
      {/* Loading */}
      <Lottie
        animationData={loading}
        loop
        style={{ height: 150, margin: "auto" }}
        // className="text-center"
      />
    </div>
  );
}
